import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { useNavigate ,Link} from 'react-router-dom'
import "./style/Allproducts.css" // Import the CSS

export default function AllProductsProfile() {
    const navigate = useNavigate()
    const [products, setProducts] = useState([])
    const [search, setSearch] = useState("")
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)
    const [shopId, setShopId] = useState(null)
    
      const api = "https://mkbackend-production.up.railway.app"
   const getUserId = () => {
        try {
            const token = localStorage.getItem('token')
            if (!token) {
                navigate('/login')
                return null
            }
            
            const base64Url = token.split('.')[1]
            const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
            const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
            }).join(''))
            
            const decoded = JSON.parse(jsonPayload)
            return decoded.id
        } catch (error) {
            console.error("Error decoding token:", error)
            return null
        }
    }

    const fetchProducts = async () => {
        const userId = getUserId()
        
        if (!userId) {
            setError("Please login to view your products")
            setLoading(false)
            return
        }

        setShopId(userId)

        try {
            setLoading(true)
            setError(null)
            
            const url = `${api}/shop-products/${userId}`
            
            const token = localStorage.getItem('token')
            const res = await axios.get(url, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            })
            
            if (res.data && res.data.products) {
                setProducts(res.data.products)
            } else {
                setProducts([])
            }
        } catch (error) {
            console.error("Error details:", error)
            setError(error.message)
            setProducts([])
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        fetchProducts()
    }, [])

    const deleteProduct = async (slug) => {
        if (!window.confirm('Are you sure you want to delete this product?')) {
            return
        }

        try {
            const token = localStorage.getItem('token')
            await axios.delete(`${api}/shop-products/${slug}`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            })
            
            setProducts(products.filter(product => product._id !== slug))
            
            // Show success feedback
            const toast = document.createElement('div')
            toast.className = 'toast'
            toast.textContent = '✅ Product deleted successfully!'
            document.body.appendChild(toast)
            setTimeout(() => toast.remove(), 3000)
            
        } catch (error) {
            console.error(error)
            alert('Failed to delete product')
        }
    }

    const editProduct = (slug) => {
        navigate(`/edit-product/${slug}`)
    }

    if (loading) {
        return (
            <div className="loading-container">
                <div className="loading-spinner"></div>
                <p className="loading-text">Loading your products...</p>
            </div>
        )
    }

    if (error) {
        return (
            <div className="error-container">
                <div className="error-box">
                    <span className="error-icon">😕</span>
                    <h2>Oops! Something went wrong</h2>
                    <p>{error}</p>
                    <button className="retry-btn" onClick={() => fetchProducts()}>
                        🔄 Try Again
                    </button>
                </div>
            </div>
        )
    }

    const filteredProducts = products.filter(product => 
        product.name && product.name.toLowerCase().includes(search.toLowerCase())
    )

    return (
        <div className="all-products-container">
            {/* Header */}
            <div className="products-header">
                <div className="products-header-left">
                    <h2>My Products</h2>
                    <button style={{border:"none" , width:"20%" , padding:"2px" , borderRadius:"2px", background:"white" }}><Link rel="stylesheet" to="/" style={{
                        color:"black"
                    }}>Home </Link></button>
                    <p className="products-count">
                        Total Products: <span>{products.length}</span>
                    </p>
                </div>
                <button 
                    className="add-product-btn"
                    onClick={() => navigate('/addproduct')}
                >
                    Add New Product
                </button>
                <button 
                className='edit-profile'
                onClick={()=>navigate('/profileedit')}>Edit Profile</button>
                <button onClick={()=>navigate('/addherosection')} className='add-hero-image'>
                    Upload Hero Image
                </button>
            </div>

            {/* Search */}
            <div className="search-container">
                <span className="search-icon">🔍</span>
                <input 
                    type="text" 
                    placeholder="Search your products..." 
                    onChange={(e) => setSearch(e.target.value)} 
                    value={search}
                />
            </div>

            {/* Products Grid */}
            {filteredProducts.length === 0 ? (
                <div className="empty-state">
                    <span className="empty-icon">📦</span>
                    <h3>{search ? 'No products found' : 'No Products Yet'}</h3>
                    <p>
                        {search 
                            ? 'Try adjusting your search' 
                            : 'Start adding your first product to showcase your shop!'}
                    </p>
                    {!search && (
                        <button 
                            className="add-first-btn"
                            onClick={() => navigate('/addproduct')}
                        >
                            ➕ Add Your First Product
                        </button>
                    )}
                </div>
            ) : (
                <div className="products-grid">
                    {filteredProducts.map((item) => (
                        <div key={item._id || Math.random()} className="product-card">
                            <span className="product-badge">In Stock</span>
                            {item.image && (
                                <img 
                                    src={item.image} 
                                    alt={item.name || 'Product'} 
                                />
                            )}
                            <h3>{item.name || 'Unnamed Product'}</h3>
                            <p className="product-price">{item.price || '0.00'}</p>
                            {item.description && (
                                <p className="product-description">
                                    {item.description}
                                </p>
                            )}
                            <div className="product-actions">
                                <button 
                                    className="edit-btn"
                                    onClick={() => editProduct(item.slug)}
                                >
                                    Edit
                                </button>
                                <button 
                                    className="delete-btn"
                                    onClick={() => deleteProduct(item.slug)}
                                >
                                    Delete
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    )
}